import { Link } from "react-router";
import { useTabs } from "../../lib/useTabs.js";
import Picture from "../Picture/Picture.jsx";
import styles from "./CaseStudyShowcase.module.css";

const BACKDROP = { ratio: "auto", widths: [960, 1600], fallbackWidth: 1600 };

/** "Nevada Department of Transportation" -> "Nevada DOT": short enough for a tab. */
const shortClient = (client) => client.replace(/\s*Department of Transportation$/, " DOT");

/**
 * Case studies as one stage instead of a row of cards: client tabs across the top, the
 * project's render filling the frame, and a card leading with the result. Tabs follow the
 * WAI-ARIA tabs pattern (arrow keys, Home/End); without JS the first study still shows.
 */
export default function CaseStudyShowcase({ items, label = "Case studies" }) {
  const { active, tabProps, panelProps } = useTabs(items.length);

  return (
    <div className={styles.stage}>
      <div className={styles.backdrops} aria-hidden="true">
        {items.map((cs, i) => (
          <Picture
            key={cs.slug}
            src={cs.image}
            alt=""
            {...BACKDROP}
            sizes="96vw"
            className={styles.backdrop}
            imgClassName={i === active ? styles.backdropActive : ""}
          />
        ))}
      </div>
      <div className={styles.scrim} aria-hidden="true" />

      <div className={styles.tabs} role="tablist" aria-label={label}>
        {items.map((cs, i) => (
          <button key={cs.slug} {...tabProps(i)} className={styles.tab}>
            {shortClient(cs.client)}
          </button>
        ))}
      </div>

      {items.map((cs, i) => (
        <div key={cs.slug} {...panelProps(i)} className={styles.panel}>
          {/* Phones stack the image above the card instead of under it. */}
          <Picture
            src={cs.image}
            alt={cs.imageAlt}
            ratio="16 / 10"
            widths={[480, 960]}
            fallbackWidth={960}
            sizes="100vw"
            className={styles.inlineImage}
          />
          <div className={styles.card}>
            {cs.highlight ? (
              <p className={styles.result}>
                <span className={styles.highlight}>{cs.highlight}</span>
                {cs.highlightText ? (
                  <span className={styles.highlightText}>{cs.highlightText}</span>
                ) : null}
              </p>
            ) : null}
            <h3 className={styles.title}>{cs.title}</h3>
            <p className={styles.client}>{cs.client}</p>
            <Link to={`/case-studies/${cs.slug}`} className={`btn btn-primary ${styles.cta}`}>
              Read the case study<span className="sr-only">: {cs.title}</span>
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
}
